import React, { createContext, useContext, useEffect, useState } from 'react';
import api, { setToken, clearToken, getToken } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      const t = getToken();
      if (!t) { setLoading(false); return; }
      try {
        const { data } = await api.get('/auth/me');
        setUser(data.user);
      } catch {
        clearToken();
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const signup = async (name, email, password, businessName = '', agreedToTerms = true, marketingConsent = true) => {
    const { data } = await api.post('/auth/signup', { name, email, password, businessName, agreedToTerms, marketingConsent });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearToken();
    setUser(null);
  };

  // Used by passwordless / magic-link flow: applies a JWT + user object that
  // the backend has already issued, without going through /login.
  const applySession = (token, userObj) => {
    setToken(token);
    setUser(userObj);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, applySession }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
